import { ErrorModel } from '@era/app';
import { ModelNameFlags } from '@era/settings-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { Category } from '../router/category';
import { WifiProfileConfiguration } from './category-wifi-profile-configuration.state';

// ============================================================================
// RESOLVER ACTIONS
// ============================================================================

export const CategoryWifiProfileResolverActions = createActionGroup({
  source: 'Category wifi profile resolver',
  events: {
    'Category wifi profiles requested': props<{ category: Category; modelNames: ModelNameFlags[] }>(),
  },
});

// ============================================================================
// API ACTIONS
// ============================================================================

export const CategoryWifiProfileApiActions = createActionGroup({
  source: 'Category wifi profile API',
  events: {
    'Category wifi profiles loaded': props<{
      wifiProfiles: WifiProfileConfiguration[];
    }>(),
    'Category wifi profiles loaded error': props<{ error: ErrorModel }>(),
    'Category wifi profile configurations updated': props<{
      category: Category;
      wifiProfiles: WifiProfileConfiguration[];
    }>(),
    'Category wifi profile configurations updated error': props<{
      category: Category;
      error: ErrorModel;
    }>(),
  },
});

// ============================================================================
// VIEW ACTIONS
// ============================================================================

export const CategoryWifiProfileViewActions = createActionGroup({
  source: 'Category wifi profile view',
  events: {
    'Wifi profile configurations updated': props<{
      category: Category;
      updatedWifiProfilesLinkedToCategory: WifiProfileConfiguration[];
    }>(),
  },
});

// ============================================================================
// EFFECT ACTIONS
// ============================================================================

export const CategoryWifiProfileEffectActions = createActionGroup({
  source: 'Category wifi profile effects',
  events: {
    'Category wifi profiles requested': props<{ category: Category; modelNames: ModelNameFlags[] }>(),
  },
});
